import underscored from 'underscore.string/underscored';

angular.module('gym.invoices').controller('PaymentAdjustmentsCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "$filter", "flash", "invoice", "currency", function($scope, $rootScope, $modalInstance, $http, $filter, flash, invoice, currency) {
  var gym, onSubmit;
  $scope.invoice = invoice;
  $scope.currency = currency;
  $scope.adjusted_amount = +invoice.amount;
  gym = $rootScope.gym;
  $scope.isReady = function() {
    return !$scope.isLoading && !$scope.getError();
  };
  $scope.getError = function() {
    var creditAmount, creditAmountPlusOne;
    if (invoice.credit_applied_amount > 0) {
      creditAmount = $filter('currency')(invoice.credit_applied_amount, currency);
      creditAmountPlusOne = $filter('currency')(+invoice.credit_applied_amount + 1, currency);
      if ($scope.adjusted_amount < invoice.credit_applied_amount) {
        return `Too low: must be ${creditAmountPlusOne} or higher, or ${creditAmount} to mark as paid by credit`;
      }
      if ($scope.adjusted_amount > invoice.credit_applied_amount && $scope.adjusted_amount < +invoice.credit_applied_amount + 1) {
        return `Invalid amount: must be ${creditAmountPlusOne} or higher, or ${creditAmount} to mark as paid by credit`;
      }
    }
  };
  onSubmit = function() {
    var contactsType, params, url;
    contactsType = `${underscored(invoice.contact_type)}s`;
    if (invoice.payment_plan_version === 'v2_invoice_plan') {
      url = `gyms/${gym.id}/${contactsType}/${invoice.contact_id}/invoice_adjustments`;
      params = {
        invoice_plan_amount_adjustment: {
          amount: $scope.adjusted_amount,
          invoice_id: invoice.id
        }
      };
      return $http.post(url, params);
    } else {
      url = `gyms/${gym.id}/${contactsType}/${invoice.contact_id}/payment_adjustments`;
      params = {
        gym_id: gym.id,
        contact_id: invoice.contact_id,
        membership_id: invoice.membership_id,
        contacts_type: contactsType,
        payment_plan_payment_adjustment: {
          adjusted_amount: $scope.adjusted_amount,
          adjustment_date: invoice.due_date
        }
      };
      return $http.post(url, params);
    }
  };
  $scope.submit = function() {
    if ($scope.getError()) {
      return;
    }
    $scope.isLoading = true;
    $scope.error = '';
    return onSubmit().then(function(data) {
      return $modalInstance.close();
    }, function(response) {
      if (response.data.error_message) {
        flash.error = response.data.error_message;
      } else {
        $scope.error = response.data.error;
      }
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
